import { Component, Input, OnInit } from '@angular/core';
import { LMBuilderModel } from "@components/builder/services/lm-builder-model.service";
import { LMFormatUtilService } from "@app/services";

@Component({
  selector:    'lm-builder-data-source',
  standalone: false,
  templateUrl: './lm-builder-data-source.component.html',
  styleUrl: './lm-builder-data-source.component.scss',
})
export class LMBuilderDataSourceComponent implements OnInit {
  @Input() spec!: LMListPSpec;

  allowArchiveReport = false;
  allowAuditReport = false;
  allowAsOfDateReport = false;
  asOfDate = '';
  isAuditData = false;
  isArchiveData = false;
  businessClass = '';
  listName = '';
  dataSource ='Transaction' ; // Soho.Locale.translate('Facade_ReportTypeLive');

  constructor(
      private lmBuilderModel: LMBuilderModel,
      private lmFormatUtilService: LMFormatUtilService
  ) {
    // no-op
  }

  ngOnInit(): void {
    this.initialize();
  }

  private initialize() {
    if (this.spec.userFolder) {
      this.allowAuditReport = this.lmBuilderModel.allowDataAuditReport();
      this.allowArchiveReport = this.lmBuilderModel.allowArchiveReport();
      this.allowAsOfDateReport = this.lmBuilderModel.allowAsOfDateReport();
      this.isAuditData = this.spec.userFolder.isAuditData;
      this.isArchiveData = this.spec.userFolder.isArchiveData;
      const _asOfDate = this.spec.userFolder.asOfDate ? this.spec.userFolder.asOfDate.toString() : '';
      this.asOfDate =  this.lmFormatUtilService.yyyymmddToDisplay(_asOfDate);
    }

    this.businessClass = this.spec.businessClass;
    this.listName = this.spec.listName;

    if (this.spec.implementsCubeView) {
      this.dataSource = 'Cube'; //Soho.Locale.translate('Facade_ReportTypePivot');
    } else if (this.spec.implementsColumnarView) {
      this.dataSource = 'Columnar'; // Soho.Locale.translate('Analytics');
    } else if (this.spec.isAuditList) {
      this.dataSource = Soho.Locale.translate('Audit');
    }
  }

  updateAsOfDate() {
    const newAsOfDate = this.lmFormatUtilService.yyyymmddToData(this.asOfDate);
    const newAsOfDateNumber = parseInt(newAsOfDate, 10);
    this.lmBuilderModel.updateAsOfDate(newAsOfDateNumber);
  }

  updateArchiveDate() {
    this.lmBuilderModel.updateArchiveData(this.isArchiveData);
  }

  updateAuditDate() {
    if (this.isAuditData && this.asOfDate.trim().length > 0) {
      this.asOfDate = '';
      this.updateAsOfDate();
    }

    this.lmBuilderModel.updateAuditData(this.isAuditData);
  }
}
